import React, { createContext, useContext, useEffect, useState } from 'react';
import API from '../config/axios';
import { api_paths } from '../config/api.paths';

const ServicesContext = createContext();

export const ServicesProvider = ({ children }) => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                setLoading(true);
                const response = await API.get(api_paths.SERVICES.get);
                const serviceList = response?.data?.payload?.data?.services || [];
                setServices(serviceList);
                // console.log("service list: ", serviceList);
            } catch (err) {
                console.error('Error fetching services:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <ServicesContext.Provider value={{ services, loading, error }}>
            {children}
        </ServicesContext.Provider>
    );
};

export const useServices = () => {
    const context = useContext(ServicesContext);
    if (!context) {
        throw new Error('useServices must be used within a ServicesProvider');
    }
    return context;
};
